import { ChartData } from '../data/ChartData';
import { ChartDataArray } from '../data/ChartDataArray';
import { ColumnBarChartAttrHandler } from './ColumnBarChartAttrHandler';
import { StackedColumnBarRenderer } from './StackedColumnBarRenderer';

export class StackedBarRenderer extends StackedColumnBarRenderer {
  constructor(gElement: d3.Selection<SVGGElement, unknown, null, undefined>, filled: boolean) {
    super(gElement, filled);
  }

  public render(
    arrays: Array<ChartDataArray>,
    x: d3.ScaleLinear<number, number>,
    y: d3.ScaleBand<string>,
    limit?: number
  ) {
    const barHeight = Math.min(StackedBarRenderer.MAX_BAR_WIDTH, y.bandwidth() - StackedBarRenderer.PADDING);
    const padding = y.bandwidth() - barHeight;

    const handlers: ColumnBarChartAttrHandler = {
      x: (d: any) => x(d[0]),
      y: (d: any) => y(<string>(<unknown>d.data.label))! + padding / 2,
      height: (_d: ChartData) => barHeight,
      width: (d: any) => x(!isNaN(d[1]) ? d[1] : 0) - x(d[0]),
    };
    super.renderInternal(arrays, handlers, limit, true);
  }

  public switchHighlight(_index: number, _highlight: boolean) {}
}
